import { TherapistAction } from 'src/redux/actions/constant';

const initialState: { isRecurringEdit: boolean | undefined } = {
  isRecurringEdit: undefined,
};

export const isRecurringEditReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TherapistAction.SET_IS_RECURRING_EDIT:
      return {
        ...state,
        isRecurringEdit: action.payload,
      };
    case TherapistAction.RESET_IS_RECURRING_EDIT:
      return initialState;
    default:
      return state;
  }
};
